import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgTagDrawn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 49,
	height: 48,
	viewBox: "0 0 49 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M28.1693 13.0574C24.4418 12.1917 16.0565 11.542 14.9954 12.0143C13.6691 12.6047 13.29 23.65 14.1859 25.024C14.468 25.4568 15.2783 26.4634 16.3151 27.7514C17.6941 29.4647 19.4741 31.6759 20.9453 33.6973C21.4904 34.4461 22.0333 35.2186 22.5682 35.9798C24.8388 39.2108 26.9662 42.2381 28.5062 42.3836C30.4363 42.5659 34.0709 39.4021 37.2591 36.4145C38.0527 35.6708 38.8449 34.9736 39.5737 34.3323C41.4064 32.7194 42.8375 31.46 42.8787 30.7036C42.9145 30.0466 40.061 26.547 36.3114 22.148C34.0281 19.4691 29.9552 14.743 28.1693 13.0574ZM17.5277 15.6609C16.9444 15.9391 15.7747 16.4971 15.9577 17.961C16.1825 19.7597 18.7308 21.877 20.3234 21.1275C21.9161 20.3781 23.2839 17.4551 21.9348 16.5932C20.5857 15.7313 19.4802 15.038 17.8126 15.5064C17.7638 15.5483 17.6611 15.5973 17.5277 15.6609Z",
			fill: "#FFD000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.3418 39.3239C22.0252 37.6325 15.0513 28.5879 12.6569 25.9916C12.4275 25.4626 11.9739 24.3063 11.9953 23.913L12.2593 19.0674C12.2937 18.4357 12.2437 15.4738 12.6112 12.6058C12.9787 9.73782 15.3909 10.7146 15.8123 10.7376L20.8689 11.013C21.9926 11.0742 27.0926 11.8453 27.7094 12.1607C28.3261 12.476 30.0833 13.8401 30.8137 14.6547C31.5442 15.4693 35.1033 19.9595 35.3651 20.326C35.6269 20.6924 40.7491 27.5217 42.1589 28.7965C43.5687 30.0712 42.4464 31.2775 41.9906 31.8866C41.5348 32.4957 34.5927 38.3867 31.1861 41.4413C27.7795 44.4959 26.4744 42.5934 26.0568 42.5003C25.6393 42.4071 24.6585 41.0153 23.3418 39.3239Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.968 18.835C10.01 18.141 6.82029 16.6183 6.11417 14.1708C4.89905 9.95904 5.96319 7.31405 8.38222 5.64502C10.8047 3.97364 14.2281 3.60863 18.2736 6.92829C22.3191 10.2479 20.8971 15.6649 20.6008 15.9305C20.3046 16.1961 19.231 19.0959 16.1179 19.349",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.1121 14.9997C16.3774 14.9377 15.395 18.0708 16.2008 19.3927C17.0066 20.7145 18.0565 20.9066 19.3584 20.8762C20.6603 20.8457 21.9578 20.5665 22.2304 18.5727C22.5029 16.5789 20.2805 15.0772 18.1121 14.9997Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTagDrawn;
